"use client"; 
// import Fallback from "@/components/ui/Fallback/Fallback";
import FallbackBrand from '@/components/ui/FallbackBrand/FallbackBrand';

export default function Loading() {
    return (
      <FallbackBrand/>
    );
  }
  